/*
 * @Author: shuchang
 * @Date: 2021-06-03 17:12:21
 * @LastEditors: shuchang
 * @LastEditTime: 2022-06-29 14:10:26
 * @Description:
 */
// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import ElementUI from "element-ui";
import "element-ui/lib/theme-chalk/index.css";
import "./assets/styles/index.scss"; // global css
import "@/assets/font/iconfont.css";

import Vue from "vue";
import App from "./App";
import router from "./router";
import "./icons";
// import "./permission.js"
import store from "@/store/store";
import axios from "axios";
import VueAxios from "vue-axios";
import VueRouter from "vue-router";
import { Message } from "element-ui";
import { getLogined, checkLogined } from "@/api/setting";
import { getMainPage } from "@/utils/getMain";
Vue.use(VueRouter);
Vue.config.productionTip = false;
Vue.use(VueAxios, axios);
Vue.use(ElementUI);
import clientWeb from "client-web";
Vue.use(clientWeb);
// /** 引入工具类函数 */
import tool from "./utils/tools";
Vue.use(tool);
Vue.prototype.tool = tool;

// 禁用浏览器前进后退
history.pushState(null, null, document.URL);
window.addEventListener("popstate", function() {
  history.pushState(null, null, document.URL);
});
// });
router.beforeEach((to, from, next) => {
  let permission = sessionStorage.getItem("data")
    ? JSON.parse(sessionStorage.getItem("data"))
    : null;
  var loginPath = "/login";
  if (to.path == loginPath) {
    window.sessionStorage.removeItem("data");
    store.commit("SET_MENU", []);
    next();
  } else if (to.path == "/home") {
    router.push("/list");
  } else {
    if (!permission) {
      router.push("/login");
    } else {
      getLogined().then((res) => {
        sessionStorage.setItem("data", JSON.stringify(res.data));
        document.cookie =
          "authority =" + sessionStorage.getItem("x-auth-token");
        sessionStorage.getItem("data");
        next();
      });
    }
  }
  // let permission = sessionStorage.getItem('data') ? JSON.parse(sessionStorage.getItem('data')) : null;
  // var loginPath = '/login';
  // if (to.path == loginPath) {
  //     window.sessionStorage.removeItem('data');
  //     store.commit('SET_MENU', []);
  // }
  // if (!permission && loginPath != '/login') {
  //         getLogined().then(res => {
  //             sessionStorage.setItem('data',JSON.stringify(res.data))
  //             document.cookie ='authority =' + sessionStorage.getItem('x-auth-token');

  //         });
  // } else {
  //   next();
  // }
});
Vue.config.productionTip = false;
// router.beforeEach((to, from, next) => {
//     console.log()
//   if (to.path === '/login') {
//       router.push('/login')
//   } else {
//       console.log('9999')
//       next()
//   }
// });
new Vue({
  el: "#app",
  router,
  store,
  components: { App },
  template: "<App/>",
});
